<template>
  <vs-popup
    id="cariSelectPopup"
    class="holamundo z-high popup-fullscreen"
    title="Cari Hesap Seçimi"
    :active.sync="isActive"
    @close="closePopup"
    fullscreen
  >
    <div class="p-4">
      <div class="mb-4">
        <div class="flex items-center justify-between">
          <h4 class="text-lg font-semibold">Cari Hesap Seçiniz</h4>
          <vs-input
            v-model="searchTerm"
            placeholder="Cari hesap ara..."
            class="w-1/3"
            icon-pack="feather"
            icon="icon-search"
          />
        </div>
      </div>

      <div v-if="isLoading" class="text-center py-4">
        <vs-loading :active="isLoading"></vs-loading>
      </div>

      <div v-else-if="filteredCariList.length === 0" class="text-center py-4">
        <p>Cari hesap bulunamadı.</p>
      </div>

      <div v-else class="cari-list-container max-h-96 overflow-y-auto">
        <vs-table :data="filteredCariList" noDataText="Cari hesap bulunamadı">
          <template slot="thead">
            <vs-th>Ad</vs-th>
            <vs-th>Telefon</vs-th>
            <vs-th>E-posta</vs-th>
            <vs-th>İşlem</vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr v-for="(cari, index) in data" :key="index">
              <vs-td>{{ cari.name }}</vs-td>
              <vs-td>{{ cari.phone }}</vs-td>
              <vs-td>{{ cari.email }}</vs-td>
              <vs-td>
                <vs-button
                  size="small"
                  type="filled"
                  color="primary"
                  @click="selectCari(cari)"
                >
                  Seç
                </vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </div>
  </vs-popup>
</template>

<script>
import { getAllCari } from "@/api/Cari";

export default {
  data() {
    return {
      isActive: false,
      isLoading: false,
      cariList: [],
      searchTerm: '',
      selectedCari: null
    }
  },

  computed: {
    filteredCariList() {
      if (!this.searchTerm) return this.cariList;

      const term = this.searchTerm.toLowerCase();
      return this.cariList.filter(cari =>
        cari.name.toLowerCase().includes(term) ||
        (cari.phone && cari.phone.includes(term)) ||
        (cari.email && cari.email.toLowerCase().includes(term))
      );
    }
  },

  methods: {
    async loadCariList() {
      try {
        this.isLoading = true;
        const response = await getAllCari();
        this.cariList = response.data;
      } catch (error) {
        this.$vs.notify({
          color: "danger",
          title: "Hata!",
          text: "Cari hesaplar yüklenirken bir hata oluştu!"
        });
      } finally {
        this.isLoading = false;
      }
    },

    selectCari(cari) {
      this.selectedCari = cari;
      this.$emit('cari-selected', cari);
      this.isActive = false;
    },

    closePopup() {
      this.searchTerm = '';
      this.selectedCari = null;
    },

    openPopup() {
      this.isActive = true;
      this.loadCariList();
    }
  }
}
</script>

<style>
/* Global stil olarak tanımlıyoruz (scoped olmadan) */
#cariSelectPopup,
#cariSelectPopup.con-vs-popup {
  z-index: 99999999 !important;
}
</style>

<style scoped>
.cari-list-container {
  border: 1px solid #eee;
  border-radius: 8px;
}
</style>
